import React from "react";
import "./Pending.css";

// Loading indicators that live *inside* the structure they stand in for, so a
// tab paints its headers, axes and layout before any data arrives.

export function Spinner({ size = 28, label = "Loading" }) {
  return (
    <div
      className="loading-spinner geo-spinner"
      role="status"
      aria-label={label}
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 10)) }}
    />
  );
}

// One row that spans a table while its body is loading.
export function PendingRow({ cols }) {
  return (
    <tr className="pending-row">
      <td colSpan={cols}><Spinner size={20} /></td>
    </tr>
  );
}

// Empty chart box with a centered spinner.
export function PendingBox({ height = 260 }) {
  return (
    <div className="pending-box" style={{ height }}><Spinner /></div>
  );
}

// Tiny spinner for the end of a text line.
export function PendingInline() {
  return <span className="pending-inline"><Spinner size={12} /></span>;
}

// Placeholder cards for a list that hasn't arrived yet.
export function GhostCards({ count = 3, className = "" }) {
  return Array.from({ length: count }, (_, i) => (
    <div key={i} className={`ghost-card ${className}`}><Spinner size={20} /></div>
  ));
}
